import { createContext } from "react";

import { IntegrationHealthInfo } from "./integrationStatus";

/**
 * How the integration cards draw: logo tiles (onboarding), full-width rows with what each
 * integration does (the Add Integration dialog), or connected rows with a status light and what
 * happened (the connected list). A context, so the dozen cards keep their own connect flows and
 * only BasicIntegrationCard changes.
 */
export const IntegrationCardLayoutContext = createContext<"tile" | "row" | "connected">("tile");

/** Set on the connected list: a linked card offers "View details" through it. */
export const IntegrationDetailsContext = createContext<((integrationId: string) => void) | undefined>(undefined);

/** The status filter chips: every row, or one tone. */
export type IntegrationStatusFilter = "ALL" | "good" | "warn" | "bad" | "idle";

/**
 * The connected list's delivery health, by base integration id (App.integrationHealth), and the
 * status filter. A row hides itself when the filter is another tone.
 */
export const IntegrationHealthContext = createContext<{ health: Record<string, IntegrationHealthInfo>; filter: IntegrationStatusFilter }>({
    health: {},
    filter: "ALL",
});
